/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_DescriptionInputs */

const en_feedback_description = /** @type {(inputs: Feedback_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const de_feedback_description = /** @type {(inputs: Feedback_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

const fr_feedback_description = /** @type {(inputs: Feedback_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const es_feedback_description = /** @type {(inputs: Feedback_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción`)
};

const it_feedback_description = /** @type {(inputs: Feedback_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione`)
};

const nl_feedback_description = /** @type {(inputs: Feedback_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschrijving`)
};

const pl_feedback_description = /** @type {(inputs: Feedback_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opis`)
};

const fi_feedback_description = /** @type {(inputs: Feedback_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuvaus`)
};

const da_feedback_description = /** @type {(inputs: Feedback_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beskrivelse`)
};

const sv_feedback_description = /** @type {(inputs: Feedback_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beskrivning`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Feedback_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const feedback_description = /** @type {((inputs?: Feedback_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_DescriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_feedback_description(inputs)
	if (locale === "fr") return fr_feedback_description(inputs)
	if (locale === "es") return es_feedback_description(inputs)
	if (locale === "it") return it_feedback_description(inputs)
	if (locale === "nl") return nl_feedback_description(inputs)
	if (locale === "pl") return pl_feedback_description(inputs)
	if (locale === "fi") return fi_feedback_description(inputs)
	if (locale === "da") return da_feedback_description(inputs)
	if (locale === "sv") return sv_feedback_description(inputs)
	return en_feedback_description(inputs)
});